// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__uikvf","start":"LandingPage_start__89DQ8"};